// extracted by mini-css-extract-plugin
export default {"calendar-component":"styles_calendar-component__N2xM5","month":"styles_month__GfiUb"};